export interface BikeModel {
    modelId: number | string;
    code: number | string;
    description: string;
    maxDistance?: number;
    maxSpeed?: number;
    pictures?: string[];
    mainPicture?: string;
    picture2?: string;
    picture3?: string;
    tariffPlans: string[] | null
}

export interface BikeModelFilter {
    options: {
        maxDistance: number,
        maxSpeed: number,
        minDistance: number,
        minSpeed: number
    },
    cache: {
        maxDistance: number,
        maxSpeed: number,
        minDistance: number,
        minSpeed: number
    },
    values: {
        maxDistance: [number, number] | undefined,
        maxSpeed: [number, number] | undefined
    },
    applied: {
        maxDistance?: [number, number],
        maxSpeed?: [number, number]
    }
}


export function getDefaultBikeModel(): BikeModel {
    return structuredClone({
        modelId: '',
        code: '',
        description: '',
        tariffPlans: null
    })
}